// extracted by mini-css-extract-plugin
export default {"tooltip":"GT-z","arrow":"HT-z"};